// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1Hvwu","wrapper":"_322Bn","margin":"_3nAHQ","section":"ubkGe","term-text":"_1IkQk"};